export default "__VITE_ASSET__DuU7xO57__"